import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import PeekabooCard from "../peekaboo-card/component"
import { row } from "./styles.module.scss"

export default function PeekabooRow({ cards }) {
  const renderCards = () => {
    return cards.map((card) => {
      return <PeekabooCard key={`card-${card.id}`} {...card} />
    })
  }

  return <div className={classNames(row)}>{renderCards()}</div>
}

PeekabooRow.propTypes = {
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      subheader: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      backgroundColor: PropTypes.string.isRequired
    })
  ).isRequired
}
